import '../adventure.css';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function Option({ image, label, color, className, to }) {
  return (
    <Link to={`/firstaid/${to}`} className={`symptom ${className}`}>
      <div className="circle" style={{ backgroundColor: color }}>
        <img src={image} alt={label} className="circle__icon" />
      </div>
      <div className="label" style={{ backgroundColor: color }}>
        {label}
      </div>
    </Link>
  );
}

Option.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};
